<div class="calendar-settings-modal">
  <div class="modal-header">
    <h2 mat-dialog-title>{{ 'client.calendarSettings.title' | translate }}</h2>
    <button mat-icon-button (click)="close()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="modal-content">
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <div *ngIf="!isLoading" class="calendar-integration-section">
      <p class="description">
        {{ 'client.calendarSettings.description' | translate }}
      </p>

      <!-- Google Calendar -->
      <div class="calendar-provider">
        <div class="provider-info">
          <div class="provider-icon google-icon">
            <fa-icon [icon]="faGoogle" size="2x"></fa-icon>
          </div>
          <div class="provider-details">
            <h3>Google Calendar</h3>
            <span
              *ngIf="calendarStatus.googleCalendarConnected"
              class="status-badge connected">
              <mat-icon>check_circle</mat-icon>
              {{ 'client.calendarSettings.connected' | translate }}
            </span>
            <span
              *ngIf="!calendarStatus.googleCalendarConnected"
              class="status-badge disconnected">
              {{ 'client.calendarSettings.notConnected' | translate }}
            </span>
          </div>
        </div>
        <div class="provider-actions">
          <button
            *ngIf="!calendarStatus.googleCalendarConnected"
            mat-raised-button
            color="primary"
            (click)="connectGoogleCalendar()">
            {{ 'client.calendarSettings.connect' | translate }}
          </button>
          <button
            *ngIf="calendarStatus.googleCalendarConnected"
            mat-stroked-button
            color="warn"
            (click)="disconnectGoogleCalendar()">
            {{ 'client.calendarSettings.disconnect' | translate }}
          </button>
        </div>
      </div>

      <mat-divider></mat-divider>

      <!-- Microsoft Calendar -->
      <div class="calendar-provider">
        <div class="provider-info">
          <div class="provider-icon microsoft-icon">
            <fa-icon [icon]="faMicrosoft" size="2x"></fa-icon>
          </div>
          <div class="provider-details">
            <h3>Microsoft Calendar</h3>
            <span
              *ngIf="calendarStatus.microsoftCalendarConnected"
              class="status-badge connected">
              <mat-icon>check_circle</mat-icon>
              {{ 'client.calendarSettings.connected' | translate }}
            </span>
            <span
              *ngIf="!calendarStatus.microsoftCalendarConnected"
              class="status-badge disconnected">
              {{ 'client.calendarSettings.notConnected' | translate }}
            </span>
          </div>
        </div>
        <div class="provider-actions">
          <button
            *ngIf="!calendarStatus.microsoftCalendarConnected"
            mat-raised-button
            color="primary"
            (click)="connectMicrosoftCalendar()">
            {{ 'client.calendarSettings.connect' | translate }}
          </button>
          <button
            *ngIf="calendarStatus.microsoftCalendarConnected"
            mat-stroked-button
            color="warn"
            (click)="disconnectMicrosoftCalendar()">
            {{ 'client.calendarSettings.disconnect' | translate }}
          </button>
        </div>
      </div>

      <!-- Meeting Provider Preference (only when both calendars connected) -->
      <div *ngIf="bothCalendarsConnected" class="meeting-preference-section">
        <mat-divider></mat-divider>
        <h3>{{ 'client.calendarSettings.preferredPlatform' | translate }}</h3>
        <p class="preference-description">
          {{ 'client.calendarSettings.preferredPlatformDescription' | translate }}
        </p>
        <mat-radio-group
          [(ngModel)]="preferredMeetingProvider"
          (change)="onMeetingProviderChange($event.value)"
          [disabled]="isUpdatingPreference"
          class="preference-radio-group">
          <mat-radio-button value="GOOGLE_MEET">
            <fa-icon [icon]="faGoogle" class="provider-radio-icon"></fa-icon>
            Google Meet
          </mat-radio-button>
          <mat-radio-button value="MICROSOFT_TEAMS">
            <fa-icon [icon]="faMicrosoft" class="provider-radio-icon"></fa-icon>
            Microsoft Teams
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">
      {{ 'client.calendarSettings.close' | translate }}
    </button>
  </mat-dialog-actions>
</div>
